/** Admin panel privilege level (`adm.prioridade` / JWT `level`). Higher = more access. */

export function parseAdminLevel(level: string | number | null | undefined): number {
  if (level === null || level === undefined || level === '')
    return 0
  const n = typeof level === 'number' ? level : Number(String(level).trim())
  return Number.isFinite(n) ? n : 0
}

export function canAccessAdminLevel(
  adminLevel: string | number | null | undefined,
  minLevel: number | null | undefined,
): boolean {
  if (!minLevel || minLevel <= 0)
    return true
  return parseAdminLevel(adminLevel) >= minLevel
}
